/**
 * @generated SignedSource<<19f323bf3bfc531beb20b4be6575f0f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ZnglyContext_App_Query$variables = Record<PropertyKey, never>;
export type ZnglyContext_App_Query$data = {
  readonly siteSettings: {
    readonly canDoAiSearch: boolean | null | undefined;
  } | null | undefined;
  readonly znglyInfo: {
    readonly znglyInfo: {
      readonly browserTabTitle: string | null | undefined;
      readonly dashboardLink: string | null | undefined;
      readonly privacyUserConsentLevel: string | null | undefined;
      readonly qrImage: {
        readonly mediaDetails: {
          readonly sizes: ReadonlyArray<{
            readonly name: string | null | undefined;
            readonly sourceUrl: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly mediaItemUrl: string | null | undefined;
      } | null | undefined;
      readonly qrPrimaryColor: string | null | undefined;
      readonly qrSecondaryColor: string | null | undefined;
      readonly searchImage: {
        readonly mediaDetails: {
          readonly sizes: ReadonlyArray<{
            readonly name: string | null | undefined;
            readonly sourceUrl: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly mediaItemUrl: string | null | undefined;
      } | null | undefined;
      readonly searchImageAi: {
        readonly mediaDetails: {
          readonly sizes: ReadonlyArray<{
            readonly name: string | null | undefined;
            readonly sourceUrl: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly mediaItemUrl: string | null | undefined;
      } | null | undefined;
      readonly searchPlaceholder: string | null | undefined;
      readonly searchPlaceholderAi: string | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"Footer_SiteInfo" | "Header_ZnglyInfo_Desktop" | "ZnglyContext_Styles_Fragment" | "analytics_Dash_Fragment">;
  } | null | undefined;
};
export type ZnglyContext_App_Query = {
  response: ZnglyContext_App_Query$data;
  variables: ZnglyContext_App_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteSettings",
  "kind": "LinkedField",
  "name": "siteSettings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canDoAiSearch",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "id",
    "value": "site-info"
  },
  {
    "kind": "Literal",
    "name": "idType",
    "value": "SLUG"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dashboardLink",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browserTabTitle",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchPlaceholder",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "privacyUserConsentLevel",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchPlaceholderAi",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaItemUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDetails",
  "kind": "LinkedField",
  "name": "mediaDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceUrl",
          "storageKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  (v7/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qrPrimaryColor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qrSecondaryColor",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = [
  (v7/*: any*/),
  (v9/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ZnglyContext_App_Query",
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ZnglyInfo",
        "kind": "LinkedField",
        "name": "znglyInfo",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Header_ZnglyInfo_Desktop"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Footer_SiteInfo"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "analytics_Dash_Fragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ZnglyContext_Styles_Fragment"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyInfo_Znglyinfo",
            "kind": "LinkedField",
            "name": "znglyInfo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "searchImage",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "searchImageAi",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "qrImage",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "znglyInfo(id:\"site-info\",idType:\"SLUG\")"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ZnglyContext_App_Query",
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ZnglyInfo",
        "kind": "LinkedField",
        "name": "znglyInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyInfo_Znglyinfo",
            "kind": "LinkedField",
            "name": "znglyInfo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "headerLogo",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerLogoLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_headerButtons",
                "kind": "LinkedField",
                "name": "headerButtons",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bgColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bgHvColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textHvColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ZnglyInfo_Znglyinfo_headerButtonsToFormConnectionEdge",
                    "kind": "LinkedField",
                    "name": "form",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Form",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "content",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "schema",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uiSchema",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "formStyle",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "formTemplate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cookieExpiration",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "submitSuccessText",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "marketingConsent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "password",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "imageUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_customSocialLinks",
                "kind": "LinkedField",
                "name": "customSocialLinks",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address3",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "linksTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_links",
                "kind": "LinkedField",
                "name": "links",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerPrimaryAccentClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerPrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerBgClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backendPrimaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backendSecondaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerSecondaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerPrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerBgClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerAccentClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fontStyle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bodyDescBoxTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bodyDescBoxClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerSecondaryAccentClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerSecondaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pagePrimaryAccClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pagePrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageSecondaryAccClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageSecondaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userMenuBackgroundClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userMenuLinkClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userMenuLinkHoverClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "catZnglistClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ddBgClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ddPrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ddSecondaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readMorePrimaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readMoreSecondaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readMorePrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaPrimaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaSecondaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaPrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareBtnPrimaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareBtnSecondaryClr",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "searchImage",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "searchImageAi",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "qrImage",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": "znglyInfo(id:\"site-info\",idType:\"SLUG\")"
      }
    ]
  },
  "params": {
    "cacheID": "6048af53ec904834b549b1da3b14274b",
    "id": null,
    "metadata": {},
    "name": "ZnglyContext_App_Query",
    "operationKind": "query",
    "text": "query ZnglyContext_App_Query {\n  siteSettings {\n    canDoAiSearch\n  }\n  znglyInfo(id: \"site-info\", idType: SLUG) {\n    ...Header_ZnglyInfo_Desktop\n    ...Footer_SiteInfo\n    ...analytics_Dash_Fragment\n    ...ZnglyContext_Styles_Fragment\n    znglyInfo {\n      dashboardLink\n      browserTabTitle\n      searchPlaceholder\n      privacyUserConsentLevel\n      searchPlaceholderAi\n      searchImage {\n        mediaItemUrl\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n        id\n      }\n      searchImageAi {\n        mediaItemUrl\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n        id\n      }\n      qrPrimaryColor\n      qrSecondaryColor\n      qrImage {\n        mediaItemUrl\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment Footer_SiteInfo on ZnglyInfo {\n  znglyInfo {\n    email\n    privacyUserConsentLevel\n    address1\n    address2\n    address3\n    linksTitle\n    links {\n      linkName\n      linkUrl\n    }\n    phone1\n    phone2\n  }\n}\n\nfragment Header_ZnglyInfo_Desktop on ZnglyInfo {\n  znglyInfo {\n    dashboardLink\n    headerLogo {\n      mediaItemUrl\n      mediaDetails {\n        sizes {\n          sourceUrl\n          name\n        }\n      }\n      id\n    }\n    headerText\n    headerLogoLink\n    headerButtons {\n      name\n      url\n      bgColor\n      textColor\n      bgHvColor\n      textHvColor\n      form {\n        node {\n          id\n          title\n          content\n          schema\n          uiSchema\n          metadata {\n            formStyle\n            formTemplate\n            cookieExpiration\n            submitSuccessText\n          }\n          marketingConsent\n          password\n          imageUrl\n        }\n      }\n    }\n    customSocialLinks {\n      name\n      url\n    }\n  }\n}\n\nfragment ZnglyContext_Styles_Fragment on ZnglyInfo {\n  znglyInfo {\n    headerPrimaryAccentClr\n    headerPrimaryTxtClr\n    headerBgClr\n    backendPrimaryColor\n    backendSecondaryColor\n    footerSecondaryTxtClr\n    footerPrimaryTxtClr\n    footerBgClr\n    footerAccentClr\n    fontStyle\n    bodyDescBoxTxtClr\n    bodyDescBoxClr\n    headerSecondaryAccentClr\n    headerSecondaryTxtClr\n    pagePrimaryAccClr\n    pagePrimaryTxtClr\n    pageSecondaryAccClr\n    pageSecondaryTxtClr\n    userMenuBackgroundClr\n    userMenuLinkClr\n    userMenuLinkHoverClr\n    catZnglistClr\n    ddBgClr\n    ddPrimaryTxtClr\n    ddSecondaryTxtClr\n    readMorePrimaryClr\n    readMoreSecondaryClr\n    readMorePrimaryTxtClr\n    ctaPrimaryClr\n    ctaSecondaryClr\n    ctaPrimaryTxtClr\n    shareBtnPrimaryClr\n    shareBtnSecondaryClr\n  }\n}\n\nfragment analytics_Dash_Fragment on ZnglyInfo {\n  znglyInfo {\n    dashboardLink\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b24146bbae1f49b988611342809a1d0";

export default node;
